import { CourseCondition, FeatureFlagsCondition, UserCondition } from './conditions';

export enum ActionButton {
    ENROLL = 'Enroll',
    WITHDRAW = 'Withdraw',
    JOIN_WAITLIST = 'JoinWaitlist',
    UN_WAITLIST = 'UnWaitlist',
    NO_BUTTON = 'NoButton',
    REQUEST_ACCESS = 'RequestAccess',
    REQUEST_ACCESS_PENDING = 'RequestAccessPending',
    REQUEST_ACCESS_APPROVED = 'RequestAccessApproved',
    REQUEST_ACCESS_REJECTED = 'RequestAccessRejected',
}

export type Condition = {
    courseCondition: CourseCondition;
    userCondition: UserCondition;
    featureFlagsCondition: FeatureFlagsCondition;
};

export enum RuleResult {
    ALLOW = 'ALLOW',
    DENY = 'DENY',
    ALLOW_REQUEST_ACCESS = 'ALLOW_REQUEST_ACCESS',
}
export type RuleType = {
    priority: number; // Higher the number, higher the priority (evaluated earlier.)
    name: string;
    resolve: (condition: Condition) => RuleResult | undefined;
};
